import { ToolInputError } from "../tool-input-error";
import { GET_SEARCH_ANALYTICS_AGGREGATED_DATA_NAME } from "./constants";

const projectErrorMessages = {
  wrongType:
    "This target is not a Search Analytics project. Select a Search Analytics project to get Google Search Console metrics.",
  missingConnection:
    "This Search Analytics project has no BigQuery connection for Google Search Console data. Configure the connection before requesting metrics.",
} as const;

/** A confirmed project-kind or connection mismatch that the model can explain or correct. */
export class SearchAnalyticsProjectInputError extends ToolInputError {
  constructor(reason: keyof typeof projectErrorMessages) {
    super(projectErrorMessages[reason]);
    this.name = "SearchAnalyticsProjectInputError";
  }
}

/** Match only messages emitted for this tool after the server has classified the error. */
export function isSearchAnalyticsProjectInputErrorText(
  toolName: string,
  errorText: string | undefined,
): boolean {
  return (
    toolName === GET_SEARCH_ANALYTICS_AGGREGATED_DATA_NAME &&
    Object.values(projectErrorMessages).some((message) => message === errorText)
  );
}
